/**
 * Utility functions for header manipulation
 */

window.T4SThemeSP = window.T4SThemeSP || {};

T4SThemeSP.HeaderUtils = (function() {
  /**
   * Temporarily hides the sticky header and shows it again on scroll
   * @param {number} timeout - Time in milliseconds before adding scroll listener (default: 5000ms)
   */
  function hideAndRestoreStickyHeader(timeout = 5000) {
    try {
      const stickyHeader = document.querySelector('.shopify-section-header-sticky');
      if (stickyHeader) {
        stickyHeader.style.opacity = '0';
      }

      // Reset after specified timeout
      setTimeout(() => {
        const handleScroll = () => {
          const stickyHeader = document.querySelector('.shopify-section-header-sticky');
          if (stickyHeader && stickyHeader.style.opacity === '0') {
            stickyHeader.style.opacity = '1';
            document.removeEventListener('scroll', handleScroll);
          }
        };
        document.addEventListener('scroll', handleScroll);
      }, timeout);
    } catch (error) {
      console.error('Error handling header options:', error);
    }
  }

  return {
    hideAndRestoreStickyHeader: hideAndRestoreStickyHeader
  };
})();
